import { useOutletContext } from "react-router-dom";
import { Shield, Users, Truck, Heart } from "lucide-react";

const DEFAULT_HERO = "https://images.pexels.com/photos/6563903/pexels-photo-6563903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1600";

const resolveUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

const PILLARS = [
  { icon: Shield, t: "Safety", d: "Every load, every mile. Safety is at the core of how we operate." },
  { icon: Users, t: "Drivers", d: "Our drivers are the face of Lucas Trans Inc. — we invest in them." },
  { icon: Truck, t: "Fleet", d: "We maintain equipment that shippers and drivers can depend on." },
  { icon: Heart, t: "Customer Service", d: "Real people, direct communication, and follow-through you can measure." },
];

export default function About() {
  const { info = {} } = useOutletContext() || {};
  const heroImg = resolveUrl(info.about_hero_image_url) || DEFAULT_HERO;
  return (
    <div>
      <section data-lt-scheme="dark" className="relative h-[52vh] min-h-[420px]">
        <img src={heroImg} alt="Highway freight" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 lt-hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-14">
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">// About</div>
          <h1 className="font-display font-black text-5xl md:text-6xl text-white uppercase leading-none">Lucas Trans Inc.</h1>
          <p className="text-slate-300 mt-3">Hoffman Estates, Illinois</p>
        </div>
      </section>

      <section className="py-20 bg-[var(--lt-bg)]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-black text-3xl md:text-4xl text-white uppercase">Our Story</h2>
          <p className="mt-6 text-slate-300 leading-relaxed text-lg">
            {info.about_story || "Lucas Trans Inc. is an American motor carrier headquartered in Hoffman Estates, Illinois. We move freight for shippers who value what old-school trucking has always been about: doing what you say, showing up on time, and treating drivers and customers with respect."}
          </p>
          <p className="mt-4 text-slate-400 leading-relaxed">
            Our mission is simple — provide dependable freight transportation with the kind of professional service that keeps shippers coming back. Whether the load is a single full truckload or a dedicated lane, our team treats every load like it matters. Because it does.
          </p>
        </div>
      </section>

      <section className="py-20 bg-[var(--lt-panel)] border-y border-[var(--lt-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-black text-3xl md:text-4xl text-white uppercase mb-10">What We Stand For</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PILLARS.map((p) => (
              <div key={p.t} className="bg-[var(--lt-bg)] border border-[var(--lt-border)] p-7">
                <p.icon className="h-6 w-6 text-[var(--lt-accent-bright)] mb-4" />
                <h3 className="font-head font-bold text-lg text-white uppercase tracking-wider">{p.t}</h3>
                <p className="text-sm text-slate-400 mt-2 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
